import React, { useState, useEffect, useCallback } from 'react';

import axios from 'axios';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';

import { Loader } from '@src/components/ui';
import Error401 from '@src/containers/errors/401error';
import Error403 from '@src/containers/errors/403error';
import Error404 from '@src/containers/errors/404error';
import Error500 from '@src/containers/errors/500error';
import { currentJwt } from '@src/utils/jwtHelpers';

const GetSignedUrlFile = ({ location }) => {
    const getJsonFromUrl = useCallback((searchParams) => {
        const result = {};
        searchParams.substr(1).split('&').forEach((part) => {
            const item = part.split('=');
            result[item[0]] = decodeURIComponent(item[1]);
        });

        return result;
    }, []);

    const [file] = useState(() => getJsonFromUrl(location.search) || {});
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleSuccess = useCallback((signedHref) => {
        window.location.href = signedHref;
        setSuccess(true);
    }, []);

    const handleError = useCallback((error) => {
        setError(error.response);
    }, []);

    const getPreSignedUrl = useCallback((id) => {
        const url = `${process.env.API_HOST_URL}/api/v1/attachments/${id}/download`;
        const token = currentJwt();
        const options = {
            headers: {
                Authorization: 'Bearer ' + token,
            },

        };

        return new Promise((resolve, reject) => {
            axios.get(url, options)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }, []);

    useEffect(() => {
        getPreSignedUrl(file.id)
            .then((success) => {
                handleSuccess(success.data.attachment.download_url);
            }).catch((error) => {
                handleError(error);
            });
    }, [file.id, getPreSignedUrl, handleSuccess, handleError]);

    const renderError = useCallback(() => {
        switch (error.status) {
        case 401:
            return <Error401 />;
        case 403:
            return <Error403 />;
        case 404:
            return <Error404 type="file" />;
        default:
            return <Error500 />;
        }
    }, [error]);

    const renderSuccess = useCallback((name) => (
        <>
            <h2>Success!</h2>
            <p><strong>{name}</strong> has been downloaded.</p>
            <p>Please check for the file in your default download folder.</p>
        </>
    ), []);

    return (
        <Col xs={12} className="post_page content-container content-view-container">
            <Card>
                <Card.Body>
                    {
                        !success && !error
                        && <Loader />
                    }
                    {
                        (success || error)
                        && <h1>Secure file download</h1>
                    }
                    {
                        !success && error
                        && renderError()
                    }
                    {
                        success
                        && renderSuccess(file.name)
                    }
                </Card.Body>
            </Card>
        </Col>
    );
};

GetSignedUrlFile.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
    }),
};

export { GetSignedUrlFile };
